import { pointConverter } from "../../../../../../../common/utils/pointConverter";

export const ViewHelper = {
  columnWidth: () => pointConverter.pointToXSizeInPixels(),
};
